<template>
  <div
    class="honeymoon-task__actor"
    v-tooltip="{ content: tooltip, placement: 'bottom', offset: 8 }"
  >
    <span class="honeymoon-task__avatar"><img :src="avatarUrl" alt=""></span>
    <span>{{ actor.full_name }}</span>
  </div>
</template>

<script>
export default {
  name: 'HoneymoonTaskActor',
  props: {
    actor: { type: Object, required: true },
    date: { type: String, default: null },
    action: { type: String, required: true },
  },
  computed: {
    avatarUrl() {
      return this.actor.crop?.crop_url || require('@/assets/img/temp/avatar-slug.jpg')
    },
    tooltip() {
      if (!this.date) return this.action
      const formattedDate = new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(this.date))
      return `${this.action} ${formattedDate}`
    },
  },
}
</script>

<style scoped>
.honeymoon-task__actor { display: inline-flex; align-items: center; gap: 6px; margin-top: 8px; color: #606060; font-size: 12px; }
.honeymoon-task__avatar { width: 22px; height: 22px; overflow: hidden; border-radius: 50%; background: #efefef; }
.honeymoon-task__avatar img { display: block; width: 100%; height: 100%; object-fit: cover; }
</style>
